import { memo, useEffect } from 'react';
import { Select } from 'antd';
import './index.less';

const INTL_OPTIONS = [
  {
    label: '中文',
    value: 'zh-CN',
  },
  {
    label: 'English',
    value: 'en-US',
  },
  {
    label: 'Français',
    value: 'fr-FR',
  },
];

const IntlSelect = () => {
  let browserLanguage = navigator.languages?.[0];

  const LanguageMap = {
    en: 'en-US',
    zh: 'zh-CN',
    fr: 'fr-FR',
  };
  // @ts-ignore
  browserLanguage = LanguageMap[browserLanguage] || browserLanguage || 'zh-CN';

  const storageLanguage = localStorage.getItem('language');

  // @ts-ignore
  const locale = ['en-US', 'zh-CN', 'fr-FR'].includes(storageLanguage)
    ? storageLanguage
    : browserLanguage;

  // 在组件挂载时检查并初始化
  useEffect(() => {
    // @ts-ignore
    if (
      typeof window !== 'undefined' &&
      (!localStorage.getItem('language') ||
        !['en-US', 'zh-CN', 'fr-FR'].includes(localStorage.getItem('language')))
    ) {
      localStorage.setItem('language', browserLanguage);
    }
  }, []);

  const onChange = (value: string) => {
    localStorage.setItem('language', value);
    window.location.reload();
  };

  return (
    <Select
      options={INTL_OPTIONS}
      className="intl-select"
      onChange={onChange}
      value={locale}
      popupMatchSelectWidth={false}
    />
  );
};

export default memo(IntlSelect);
